import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BinocularIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.64727 2.24201L1.16 11C1.04983 11.3123 1 11.65 1 12C1 13.6569 2.34315 15 4 15C5.65685 15 7 13.6569 7 12V9.5C7 9.03385 7.32253 8.52207 7.78816 8.5C7.92931 8.49331 8.07069 8.49331 8.21184 8.5C8.67747 8.52207 9 9.03385 9 9.5V12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 11.65 14.9502 11.3123 14.84 11L12.3527 2.24201C12.144 1.50709 11.4729 1 10.7089 1C9.76509 1 9 1.76509 9 2.70887V4.13378C8.70583 4.0487 8.36429 4 8 4C7.63571 4 7.29417 4.0487 7 4.13378V2.70887C7 1.76509 6.23491 1 5.29113 1C4.52715 1 3.85598 1.50709 3.64727 2.24201ZM2.5 12C2.5 11.1716 3.17157 10.5 4 10.5C4.82843 10.5 5.5 11.1716 5.5 12C5.5 12.8284 4.82843 13.5 4 13.5C3.17157 13.5 2.5 12.8284 2.5 12ZM12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5Z"
		></path>
	</svg>
))
